// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2Nu2k","inputWrap":"Table_inputWrap__14vw1","col":"Table_col__2iLfZ","bmiTooltip":"Table_bmiTooltip__1sOUd"};